import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79dfccb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-header-title w-full -ml-2 -mr-2" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "mt-2 mr-2 ml-0 mb-0 font-normal" }
const _hoisted_4 = {
  key: 0,
  class: "col-4 col-offset-2 flex justify-content-end align-items-center"
}
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "m-0" }

import { ref, withDefaults, onBeforeMount, inject, computed } from "vue";
import { useStore } from "vuex";
import Button from "primevue/button";
import { Fn, get, set } from "@vueuse/core";
import { IBooking } from "@/clinic/typings";
import { BookingActionEnum } from "@/clinic/typings/enums/booking";
import { EventClickArg } from "@fullcalendar/core";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

/**
 * Vuexストアのインスタンス
 */
type IHeaderShowSidebar = {
  /** 予約ID */
  bookingId: string | undefined;
  /** 予約タイプ（通常予約、リクエスト予約など） */
  bookingType: string | undefined;
  /** 予約ステータス（will_come、cancelledなど） */
  bookingStatus: string | undefined;
  /** リクエスト予約のステータス（approved、pendingなど） */
  bookingRequestStatus?: string | undefined;
  /** FullCalendarのイベント引数 */
  eventArg: EventClickArg;
  /** 自由予約フラグ */
  is_free_space?: boolean;
  /** 予約オブジェクト */
  booking?: IBooking;
};

/**
 * 予約サイドバー表示関数の参照
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
    bookingId: { default: "" },
    bookingType: { default: "" },
    bookingStatus: { default: "" },
    bookingRequestStatus: null,
    eventArg: { default: () => ({} as EventClickArg) },
    is_free_space: { type: Boolean },
    booking: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { bookingId: string | undefined, bookingType: string | undefined, bookingStatus: string | undefined, bookingRequestStatus?: string | undefined, eventArg: EventClickArg, is_free_space?: boolean, booking: IBooking };

/**
 * Vue 3 Composition APIの基本機能
 * - ref: リアクティブな参照を作成
 * - withDefaults: プロパティのデフォルト値を設定
 * - defineProps: コンポーネントのプロパティを定義
 * - onBeforeMount: コンポーネントマウント前のライフサイクルフック
 * - inject: 親コンポーネントから値を注入
 * - computed: 計算されたプロパティを作成
 */
const store = useStore();

/**
 * 予約詳細ヘッダーサイドバーのプロパティ型定義
 */
const onShowBookingSidebar = ref<Fn>();

/**
 * コンポーネントのプロパティ定義
 * デフォルト値を設定
 */


/**
 * 編集ボタンクリック時の処理
 * 予約編集サイドバーを開く
 */
const goToEdit = () => {
  const editBookingSidebarFn =
    get(onShowBookingSidebar) ||
    ((_booking: IBooking, _action: string, _eventArg: EventClickArg) => ({ _booking, _action, _eventArg }));
  editBookingSidebarFn({ id: props.bookingId } as unknown as IBooking, BookingActionEnum.edit, props.eventArg);
};

/**
 * 複製ボタンクリック時の処理
 * 予約複製サイドバーを開く
 */
const goToDuplicate = () => {
  const editBookingSidebarFn =
    get(onShowBookingSidebar) ||
    ((_booking: IBooking, _action: string, _eventArg: EventClickArg) => ({ _booking, _action, _eventArg }));
  editBookingSidebarFn({ id: props.bookingId } as unknown as IBooking, BookingActionEnum.duplicate, props.eventArg);
};

/**
 * 自由予約かどうかを判定する
 * @returns {boolean} 自由予約の場合はtrue
 */
const isFreeSpace = computed(() => {
  return !!props.is_free_space;
});

/**
 * 編集ボタンの表示条件を計算
 * @returns {boolean} 編集可能な場合はtrue
 */
const canEdit = computed(() => {
  // リクエスト予約の場合、承認済み（approved）の場合のみ編集可能
  if (props.bookingType === "request") {
    // booking_request_statusが"approved"の場合のみ編集可能
    // この値は親コンポーネントから渡される必要があります
    return props.bookingRequestStatus === "approved";
  }
  // 通常予約や繰り返し予約の場合は従来通り
  return true;
});

/**
 * コンポーネントマウント前に予約サイドバー表示関数を注入
 */
onBeforeMount(() => set(onShowBookingSidebar, inject<Fn>("onShowBookingSidebar")));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(isFreeSpace) ? "自由予約詳細" : "予約詳細"), 1)
    ]),
    (props.bookingType != 'request' && props.booking?.start_time && props.booking?.end_time)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Unaffiliated)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                label: "予約の複製",
                class: "btn-duplicate mr-3",
                size: "small",
                onClick: goToDuplicate
              }))
            : _createCommentVNode("", true),
          (_unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Unaffiliated && _unref(canEdit))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                label: "編集",
                class: "btn-white",
                size: "small",
                onClick: goToEdit,
                disabled: props.bookingStatus != 'will_come'
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, "予約番号：" + _toDisplayString(props.bookingId), 1)
    ])
  ]))
}
}

})